const WorkingHours = () => {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
      className="location__mood"
    >
      <path
        d="M5.333 32c0-14.747 11.92-26.667 26.64-26.667 14.747 0 26.694 11.92 26.694 26.667 0 14.747-11.974 26.667-26.694 26.667-14.72 0-26.64-11.92-26.64-26.667Z"
        fill="#aed58e"
        className="mood__bg"
      ></path>
      <path
        d="M31.974 5.333C17.254 5.333 5.334 17.28 5.334 32c0 14.72 11.92 26.667 26.64 26.667C46.72 58.667 58.666 46.72 58.666 32c0-14.72-11.947-26.667-26.694-26.667Zm.026 48c-11.787 0-21.333-9.546-21.333-21.333 0-11.787 9.546-21.333 21.333-21.333 11.787 0 21.334 9.546 21.334 21.333 0 11.787-9.547 21.333-21.334 21.333Z"
        fill="#000"
        fillOpacity=".2"
        className="mood__border"
      ></path>
      <path
        d="M41.333 29.333a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-18.666 0a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM32 42.667c-3.947 0-7.333-2.16-9.2-5.334h-4.453C20.48 42.8 25.787 46.667 32 46.667s11.52-3.867 13.653-9.334H41.2c-1.867 3.174-5.253 5.334-9.2 5.334Z"
        fill="#000"
        className="mood__face"
      ></path>
    </svg>
  );
};

export default WorkingHours;
